import { INTERACTION_BEHAVIOR_TYPE_INTERNAL_LINK, INTERACTION_BEHAVIOR_TYPE_EXTERNAL_LINK, INTERACTION_BEHAVIOR_TYPE_INTERNAL_LINK_CLICKTHROUGH, INTERACTION_BEHAVIOR_TYPE_EXTERNAL_LINK_CLICKTHROUGH, INTERACTION_STYLE_TO_CLASSNAME } from './constants';
import { applyFilters } from '../../utils/arrays';
export function interactionIsUsable(interaction) {
  return interaction && interaction.enabled && interaction.url;
}
export function interactionIsClickthrough(interaction) {
  var clickThroughTypes = [INTERACTION_BEHAVIOR_TYPE_INTERNAL_LINK_CLICKTHROUGH, INTERACTION_BEHAVIOR_TYPE_EXTERNAL_LINK_CLICKTHROUGH];
  return interaction && clickThroughTypes.includes(interaction.behaviorType);
}
export function interactionIsLink(interaction) {
  var linkTypes = [INTERACTION_BEHAVIOR_TYPE_INTERNAL_LINK, INTERACTION_BEHAVIOR_TYPE_EXTERNAL_LINK];
  return interaction && linkTypes.includes(interaction.behaviorType);
}
export function getInteractionClassName(_ref) {
  var style = _ref.style;
  return INTERACTION_STYLE_TO_CLASSNAME[style] || '';
}
export function splitInteractionsIntoClickthroughAndLink(interactions) {
  var clickThroughInteractions = applyFilters(interactions, interactionIsUsable, interactionIsClickthrough);
  var linkInteractions = applyFilters(interactions, interactionIsUsable, interactionIsLink);
  return [clickThroughInteractions, linkInteractions];
}
export function getNonClickthroughInteractions(interactions) {
  var nonClickThroughInteractions = applyFilters(interactions, interactionIsUsable, function (interaction) {
    return !interactionIsClickthrough(interaction);
  });
  return nonClickThroughInteractions;
}
export function getClickthroughInteractions(interactions) {
  var clickThroughInteractions = applyFilters(interactions, interactionIsUsable, interactionIsClickthrough);
  return clickThroughInteractions;
}